<template>
    <component
        :is="display"
        :manufacturer="manufacturer"
        :display-setting="displaySetting"
        :is-price-books="isPriceBooks"
    />
</template>

<script setup>
import { computed } from "vue";
import { useUser } from "@/Composables";
import MarketingManufacturerCard from "../../../Themes/Marketing/Components/Modules/Cards/ManufacturerCard.vue";
import SourcingManufacturerCard from "../../../Themes/Sourcing/Components/Modules/Cards/ManufacturerCard.vue";

const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode
        ? SourcingManufacturerCard
        : MarketingManufacturerCard
);

defineProps(["manufacturer", "displaySetting", "isPriceBooks"]);
</script>
